if (!customElements.get('product-sticky-atc')) {
  class ProductStickyAtc extends HTMLElement {
    constructor() {
      super()
      this._observer = null
    }

    connectedCallback() {
      this.init()
    }

    disconnectedCallback() {
      if (this._observer) {
        this._observer.disconnect()
        this._observer = null
      }
    }

    init() {
      ;(this._productForm = document.querySelector('product-form.main-form')),
        this._productForm &&
          ((this._atcButtonAnchor = this._productForm.querySelector(
            '.product-form__anchor'
          )),
          this._initObserver())
    }

    _initObserver() {
      let lastY = null
      let hasScrolled = false

      this._observer = new IntersectionObserver(
        ([entry]) => {
          const currentY = entry.boundingClientRect.top

          // Skip first run or scroll to top to avoid false trigger
          if (!hasScrolled || currentY === 0) {
            document.body.classList.remove('product-cta-out-of-view')
            lastY = currentY
            hasScrolled = true
            return
          }

          const isScrollingDown = currentY < lastY

          if (entry.isIntersecting) {
            // Always hide CTA when anchor is in view
            document.body.classList.remove('product-cta-out-of-view')
          } else if (isScrollingDown) {
            // Only show CTA when anchor is out of view AND scrolling down
            document.body.classList.add('product-cta-out-of-view')
          }

          lastY = currentY
        },
        {
          root: null,
          threshold: 0,
          rootMargin: `0px 0px 0px 0px`,
        }
      )

      this._observer.observe(this._atcButtonAnchor)
    }
  }

  customElements.define('product-sticky-atc', ProductStickyAtc)
}
